import { Form } from "antd";
import { useCallback, useMemo } from "react";
import { ESupportLanguageOfSupport } from "@devowl-wp/api-real-commerce";
import { localStorageTest } from "../utils/localStorageTest.js";
const LOCAL_STORAGE_RESTORE_FORM_VALUES = "real-commerce-support-restore-values";
/**
 * Allows to recover from saved values in the `localStorage`.
 */ function useRecoverableSupportForm(param) {
    let { forceProduct, forceQuestionType } = param;
    const isRestorableFromLocalStorage = useMemo(()=>localStorageTest(), []);
    const [form] = Form.useForm();
    // Determine default language of support
    const { lang } = document.documentElement;
    const languageOfSupport = lang.startsWith("de") ? ESupportLanguageOfSupport.German : ESupportLanguageOfSupport.English;
    const initialValues = {
        name: "",
        email: "",
        product: undefined,
        bought: false,
        licenseKey: "",
        questionType: undefined,
        languageOfSupport,
        concern: "",
        // Virtual fields: Are only concatenated to the message field for custom offers
        companyName: "",
        numberOfNeededLicenses: undefined,
        screenRecording: undefined,
        wpSiteHealth: undefined,
        wpHealthExport: "",
        errorLocation: "",
        existsErrorInMultipleBrowsers: undefined,
        browserToReproduceError: "",
        errorPersistsWithoutProduct: undefined,
        errorPersistsWithoutThirdPartyProduct: undefined,
        faultyThirdPartyProduct: "",
        provideAccessData: undefined,
        accessDataUrl: "",
        accessDataUsername: "",
        accessDataPassword: "",
        accessDataDeleteAcknowledgment: false,
        message: "",
        attachments: [],
        terms: false,
        dpa: false,
        disableEmailCheck: false,
        disableMaintenanceModeCheck: false
    };
    // Restore from localStorage
    const restoredValues = isRestorableFromLocalStorage ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_RESTORE_FORM_VALUES) || "{}") : {};
    Object.assign(initialValues, restoredValues);
    /**
     * Delete restorable values as we can start the form from scratch next time.
     */ const eraseMemorizedValues = useCallback(()=>{
        isRestorableFromLocalStorage && localStorage.removeItem(LOCAL_STORAGE_RESTORE_FORM_VALUES);
    }, []);
    /**
     * Pass values to make them restorable with the help of `localStorage`.
     */ const makeRestorable = useCallback((values)=>{
        // Find all restorable values
        const { dpa, terms, disableEmailCheck, disableMaintenanceModeCheck, accessDataPassword, accessDataDeleteAcknowledgment, screenRecording, attachments, ...restorable } = values;
        isRestorableFromLocalStorage && localStorage.setItem(LOCAL_STORAGE_RESTORE_FORM_VALUES, JSON.stringify(restorable));
    }, []);
    Object.assign(initialValues, {
        ...forceProduct ? {
            product: forceProduct
        } : {},
        ...forceQuestionType ? {
            questionType: forceQuestionType
        } : {}
    });
    return {
        initialValues,
        form,
        eraseMemorizedValues,
        makeRestorable
    };
}
export { useRecoverableSupportForm };
